import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyService} from '../../services/currency.service';

@Pipe({name: 'currencySymbol'})
export class CurrencySymbolPipe implements PipeTransform {

  constructor(private currencyService: CurrencyService) {
  }

  transform(currencySlug: string): string {
    const currency = this.currencyService.getBySlug(currencySlug) || this.currencyService.findCurrencies()[0];
    return currency.symbol;
  }

}
